import { SET_FILTERED_VEHICLES, CLEAR_FILTERED_VEHICLES, SET_VEHICLE_PAGE_NUMBER } from '../types'

export const setFilteredVehicles = (data) => ({
  type: SET_FILTERED_VEHICLES,
  payload: data,
});

export const clearFilteredVehicles = () => ({
  type: CLEAR_FILTERED_VEHICLES,
})

export const setVehiclePageNumber = (pageNumber) => ({
  type: SET_VEHICLE_PAGE_NUMBER,
  payload: pageNumber,
})